<template>
  <v-sheet color="transparent" height="100%" width="100%" class="d-flex align-center justify-center primary--text font-weight-bold">
    <!-- <p>TEMP 404 PAGE NOT FOUND :(</p> -->
    <v-img src="https://media.eipl.org/site/images/site/404-transparent-primary.png" contain height="50vh" width="80vh"></v-img>
  </v-sheet>
</template>

<script>
  export default {}
</script>

<style></style>
